import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "@/App"
import { initAnalytics } from "@/shared/analytics/umami"
import "@/styles/index.css"

const container = document.getElementById("root")

if (!container) {
  throw new Error("Elemento #root nao encontrado no index.html.")
}

// Antes do render: o script e `defer`, entao entra na fila sem atrasar a
// primeira pintura, e ja esta pronto quando a pagina termina de carregar.
initAnalytics()

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
